/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff1a0601d1dfa1b068f5f916af0a8fe>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const LightbulbIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a4.5 4.5 0 0 0-2.516 8.232c.545.368 1.002.994 1.016 1.768h3c.014-.774.471-1.4 1.016-1.768A4.5 4.5 0 0 0 8 1.5M9.5 13h-3v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM2 6a6 6 0 1 1 9.355 4.975c-.247.167-.355.385-.355.56V14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2.465c0-.175-.108-.393-.355-.56A6 6 0 0 1 2 6" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
LightbulbIcon.displayName = 'LightbulbIcon';
var _default = exports.default = LightbulbIcon;